import Component from "../../lib/component";
import {ReviewItem, ReviewItemConfig} from "./review_item";
import {ReplyToggler, ReplyTogglerConfig} from "./reply_toggler";

export const ReviewConfig = {
    componentTypeKey: 'Review',
    baseHtmlClass: 'review',
    selector: '.review',

    datasetConfigKey: 'review__config',
    favoriteDatasetConfigKey: 'favorited',
};

/**
 * The Review component.
 */
export class Review extends Component {

    static get config() {
        return ReviewConfig;
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: Review.config
        });

        this.setDatasetConfig(Review.config.datasetConfigKey);
        this.isFavorite = this.getIsFavorite();

        this.reviewItems = [];
        const itemElements = this.element.querySelectorAll(ReviewItemConfig.selector);
        itemElements.forEach((element) => {
            this.reviewItems.push(new ReviewItem(element, this));
        });

        this.viewingReply = false;
        this.replyTogglers = getReplyTogglers(this);

        this.inited = true;
        this.render();
    }

    handleReplyTogglerClick() {
        this.viewingReply = !this.viewingReply;
        this.render();
    }

    getIsFavorite() {
        const favorite = this.getDatasetConfigValue(Review.config.favoriteDatasetConfigKey);
        return !!favorite;
    }

    render() {
        this.conditionallySetHtmlClassState(this.inited, 'inited');
        this.conditionallySetHtmlClassState(this.isFavorite, Review.config.favoriteDatasetConfigKey);
        this.reviewItems.forEach(item => item.render());
        this.replyTogglers.forEach(replyToggler => replyToggler.render());
        this.conditionallySetHtmlClassState(this.viewingReply, 'viewing_reply');
    }

}

function getReplyTogglers(review) {
    let replyTogglers = [];
    review.element.querySelectorAll(ReplyTogglerConfig.selector).forEach((element) => {
        replyTogglers.push(new ReplyToggler(element, review));
    });
    return replyTogglers;
}
